module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-reset"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Reset Password")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Password",
      "required": "",
      "type": "password",
      "counter": "",
      "min": _vm.passwordLength,
      "rules": [_vm.passwordStrength]
    },
    model: {
      value: (_vm.passwordReset1),
      callback: function($$v) {
        _vm.passwordReset1 = $$v
      },
      expression: "passwordReset1"
    }
  }, [_vm._v("\n        >")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Password",
      "required": "",
      "type": "password",
      "counter": "",
      "rules": [_vm.passwordsEqual]
    },
    model: {
      value: (_vm.passwordReset2),
      callback: function($$v) {
        _vm.passwordReset2 = $$v
      },
      expression: "passwordReset2"
    }
  }, [_vm._v("\n        >")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setVisible(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset Password")])], 1)], 1)], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2f5a9d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/PasswordReset.vue
// module id = 454
// module chunks = 1